import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LayoutModule } from '@angular/cdk/layout';
import { LottieComponent } from 'ngx-lottie';

import { ToastrComponent } from './toastr.component';
import { ToastItemComponent } from './toast-item.component';

@NgModule({
  declarations: [
    ToastrComponent,
    ToastItemComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressBarModule,
    LayoutModule,
    LottieComponent
  ],
  exports: [
    ToastrComponent
  ]
})
export class ToastrModule { } 